import { render, staticRenderFns } from "./MostRecentCompletions.vue?vue&type=template&id=632abf58&scoped=true"
import script from "./MostRecentCompletions.vue?vue&type=script&lang=js"
export * from "./MostRecentCompletions.vue?vue&type=script&lang=js"
import style0 from "./MostRecentCompletions.vue?vue&type=style&index=0&id=632abf58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632abf58",
  null
  
)

export default component.exports